import type { TFunction } from 'i18next';

import { ToastInfo } from '@/components/molecules/ToastTemplate/ToastTemplate';
import { dismissToast } from '@/components/molecules/ToastTemplate/toastStore';

import type { SaveOutcome } from '../hooks/useProviderCardForm';

/** As long as the portal's other info toasts stay up. */
const CONFLICT_AUTO_CLOSE_MS = 8000;

const conflictToastId = (providerName: string): string =>
    `provider-config-conflict-${providerName}`;

/**
 * The toast for one save's outcome. A save that lands takes away the conflict warning of an
 * earlier attempt, which it has just resolved.
 */
export function showSaveOutcomeToast(
    t: TFunction,
    providerName: string,
    outcome: SaveOutcome,
    onlyDeactivated: boolean
): void {
    if (outcome === 'saved') {
        dismissToast(conflictToastId(providerName));
        ToastInfo({
            // Turning pens off leaves the next fetch nothing new to read for them.
            content: t(
                onlyDeactivated
                    ? 'providerConfig.toast.savedInactive'
                    : 'providerConfig.toast.saved'
            ),
            status: 'success',
            icon: 'success',
            options: { toastId: `provider-config-saved-${providerName}`, autoClose: 5000 },
        });
    }
    if (outcome === 'conflict')
        ToastInfo({
            content: t('providerConfig.toast.conflict'),
            status: 'warning',
            type: 'warning',
            icon: 'optoscale',
            options: {
                toastId: conflictToastId(providerName),
                autoClose: CONFLICT_AUTO_CLOSE_MS,
            },
        });
}
